import React from 'react';

import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import WebpImage from '@r1-frontend/ui-react/components/WebpImage';
import { RoundedBlock } from '@r1-frontend/ui-react/experimental/blocks';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import * as ST from './styled';

const starFull = '/static/images/grades/star-full';
const starHalf = '/static/images/grades/star-half';

const AverageGrade = () => {

    return (
        <ST.Wrapper>
            <ST.Label
                data-test='average-grade-label'
                $withIndent={false}
                $inline={true}
                as={'h1'}
            >
                Отзывы о Дом.ру
            </ST.Label>
            <ST.ContentWrapper>
                <ST.GradeBlock>
                    <ST.GradeNumber
                        data-test='average-grade-number'
                        $withIndent={false}
                        $inline={true}
                        as={'span'}
                    >
                        4.7
                    </ST.GradeNumber>
                    <ST.Stars data-test='average-grade-stars'>
                        {
                            [...Array(5)].map((_, index) => {
                                return (<WebpImage
                                    key={`aver_grade_star_${index}`}
                                    urlWebp={`${index < 4 ? starFull : starHalf}.webp`}
                                >
                                    <ST.Star data-test='grade-help-image' src={`${index < 4 ? starFull : starHalf}.png`} />
                                </WebpImage>);
                            })
                        }
                    </ST.Stars>
                </ST.GradeBlock>
                <RoundedBlock
                    $radius={BorderRadius.componentRadius}
                    $bgColor={COLORS.BgMain}
                >
                    <Paragraph4 data-test='average-grade-text'>
                        {'Сейчас мы собираем отзывы на отзывы.ру и других сайтах. Вскоре можно будет написать их прямо на этой странице — мы работаем над этим.'}
                    </Paragraph4>
                </RoundedBlock>
            </ST.ContentWrapper>
        </ST.Wrapper>
    );
};

export default AverageGrade;
